import React from "react";
import ActivityMessaging from "../../../../../../store/ActivityMessaging.store";
import BackIcon from "../../../../../../assets/Icons/Pages/Organizational/Management/Activities/ArrowLeft.svg";
import PropTypes from "prop-types";
const MessagingHistory = ({ data, setProfileData }) => {
  const { setMessageId } = ActivityMessaging();

  return (
    <div className="flex-col align-start justify-start g-1 p-t-2 p-l-1 p-r-1 p-b-1 h-full">
      <div className="messagingHistoryHeader flex-row align-center justify-start g-1">
        <button
          className="transparentCardBtn"
          style={{ border: "none", width: "1.2rem", height: "1.2rem" }}
          onClick={() => {
            setMessageId("");
            setProfileData(null);
          }}
        >
          <img
            src={BackIcon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </button>
        <div className="flex-row align-center justify-start g-1">
          <div
            style={{
              width: "3rem",
              height: "3rem",
              borderRadius: "50%",
              backgroundColor: data && data.color,
            }}
          ></div>
          <h3 className="weight-500 poppins-medium t-14">
            {data && data.title}
          </h3>
        </div>
      </div>
      <div className="flex-col align-end justify-start g-1 w-full scroll-y  flex-1 p-r-1">
        <MessagingHistoryInsideMsg
          date={" 10 AM, 02 Nov, 2024"}
          msg={
            " Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aperiam provident obcaecati architecto"
          }
        />
        <MessagingHistoryInsideMsg
          date={" 10 AM, 02 Nov, 2024"}
          msg={
            " Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aperiam provident obcaecati architecto"
          }
        />
        <MessagingHistoryInsideMsg
          date={" 10 AM, 02 Nov, 2024"}
          msg={
            " Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aperiam provident obcaecati architecto"
          }
        />
        <MessagingHistoryInsideMsg
          date={" 10 AM, 02 Nov, 2024"}
          msg={
            " Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aperiam provident obcaecati architecto"
          }
        />
        <MessagingHistoryInsideMsg
          date={" 10 AM, 02 Nov, 2024"}
          msg={
            " Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aperiam provident obcaecati architecto"
          }
        />
      </div>
    </div>
  );
};

export default MessagingHistory;
MessagingHistory.propTypes = {
  data: PropTypes.object.isRequired,
  setProfileData: PropTypes.func.isRequired,
};

const MessagingHistoryInsideMsg = ({ date, msg }) => {
  return (
    <div className="messagingHistoryInsideMsg">
      <span className="t-12 color-grayBorder poppins weight-500">{date}</span>
      <div className="flex-col back-blueColor1 color-white poppins t-13">
        {msg}
      </div>
    </div>
  );
};

MessagingHistoryInsideMsg.propTypes = {
  date: PropTypes.string.isRequired,
  msg: PropTypes.string.isRequired,
};
